import React, { Dispatch, memo, SetStateAction } from 'react';
import { IconClose } from '../../assests/icons/ModalIcons';
import { BackBoxIcon, DashboardIcon, HourglassIcon } from '../../assests/icons/Icons';
import { Button } from '../../Components/Button';
import { PVNXT_MODE } from '../../Utils/Const';



export type ModeOptionTy = "pvNXT Mode" | "Self Mode";
interface LeadSuccessModalProps {mode: ModeOptionTy; handleClose?: Dispatch<SetStateAction<boolean>>;onGoToDashboard?: () => void;}

export const LeadSuccessModal = ({ mode, handleClose, onGoToDashboard } : LeadSuccessModalProps) => {
  
  // Content mapping based on the mode prop
  const content = {
    "pvNXT Mode": {
      title: `Lead shared with ${PVNXT_MODE}`,
      description: "We're preparing your final solar plan. Our experts are reviewing your roof, system design, and savings to create the most accurate proposal for you.",
      subtext: "Usually ready within 48 hours. You'll be notified once it's ready."
    },
    "Self Mode": {
      title: "Your lead has been shared with installers.",
      description: "Your request has been shared with verified installers. They will review your details and contact you with proposals tailored to your requirements.",
      subtext: "You can compare the proposals and choose the option that best suits your needs."
    }
  };

  const activeContent = content[mode];

  return (
    <div className="modal-backdrop1 fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="main-modal2 bg-white rounded-2xl p-6 max-w-md w-full mx-4 shadow-xl relative text-center">

        {/* Hourglass Icon Container */}
        <div className="flex justify-center mb-6">
          <div className="w-10 h-10 bg-orange-50 rounded-full flex items-center justify-center text-2xl"><HourglassIcon /> </div>
        </div>

        {/* Content Section */}
        <div className="space-y-4 mb-6">
          <h2 className="text-[22px] font-semibold text-gray-900 leading-tight">
            {activeContent.title}
          </h2>
          
          <p className="text-gray-600 text-[14px] leading-relaxed">
            {activeContent.description}
          </p>
          
          <p className="text-gray-600 text-sm">
            {activeContent.subtext}
          </p>
        </div>

        {/* Dashboard Button */}
        {/* <Button className="btn btn-sm-outlineprimary w-full" LeftIcon={<DashboardIcon />} name={"Back to Dashboard"} onClick={()=>onGoToDashboard?.()} /> */}
        {/* <Button className="btn btn-sm-outlineprimary w-full" LeftIcon={<BackBoxIcon />} name={"Back to project"} onClick={()=>handleClose?.(false)} /> */}
        <Button className="btn btn-sm-outlineprimary w-full" LeftIcon={<BackBoxIcon />} name={"Back to Dashboard"} onClick={()=>onGoToDashboard?.()} />
      </div>
    </div>
  );
};